import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomFormComponent } from '@bo-client/activation-management/custom-form.component';
import { GridRegistrationModel } from '@bo-client/activation-management/grid-registration/model/grid-registration.model';
import { DataForCustomFormModel } from '@bo-client/activation-management/shared/models/actionWithMoreInfo.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CreateGridRegistrationFormsService } from '@bo-client/activation-management/grid-registration/create-grid-registration-forms.service';

@Component({
  selector: 'app-malo-melo-form',
  templateUrl: './malo-melo-form.component.html',
  styleUrls: ['./malo-melo-form.component.scss']
})
export class MaloMeloFormComponent
  implements CustomFormComponent<GridRegistrationModel, GridRegistrationModel>, OnInit
{
  @Input() data: DataForCustomFormModel<GridRegistrationModel>;
  @Output() onConfirm: EventEmitter<GridRegistrationModel> = new EventEmitter();

  public model: GridRegistrationModel;
  public currentForm: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.model = this.data.model;
    this.currentForm = this.fb.group({
      maLo: [this.model.maLo, Validators.required],
      meLo: [this.model.meLo, Validators.required]
    });
  }

  cancel() {
    this.onConfirm.emit(null);
  }

  confirm() {
    if (this.currentForm.valid) {
      this.model = {
        ...this.model,
        ...this.currentForm.value
      };
      this.onConfirm.emit(this.model);
    } else {
      this.currentForm.markAllAsTouched();
    }
  }
}
